// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"total-attending__wrapper__3dNcg","status-wrapper":"total-attending__status-wrapper__z5bJ_","order-status":"total-attending__order-status__ovmRO","total-status-link":"total-attending__total-status-link__3MkMe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/total-attending.scss
// module id = 1258
// module chunks = 1